import { PointerSensor, PointerSensorProps } from '@dnd-kit/core';

// dnd-kit's PointerSensor, made to notice a release it never received.
//
// From the press on a handle until its `pointerup`, dnd-kit holds the drag
// open (pending, or active once the pointer travels far enough) and ignores
// every other press. Safari sometimes never delivers that release. The handle
// then stops answering until a click elsewhere supplies a `pointerup`, and in
// the meantime plain mouse movement, with no button held, picks the row up:
// it follows the cursor, and the next click (on an item's pause button, say)
// lands on the row's own handle and drops it, reordering the list instead.
//
// A move with no button pressed proves the release happened. On the first
// one this sends the missing `pointerup` to the document, where dnd-kit
// listens, before dnd-kit sees the move: a pending press is abandoned, and a
// drag already under way drops where the pointer is.
export class ReleaseAwarePointerSensor extends PointerSensor {
  constructor(props: PointerSensorProps) {
    super(props);
    var doc = (props.event.target as Node | null)?.ownerDocument || document;

    function onMove(e: PointerEvent) {
      if (e.buttons !== 0) return;
      stop();
      doc.dispatchEvent(
        new PointerEvent('pointerup', {
          bubbles: true,
          clientX: e.clientX,
          clientY: e.clientY,
          pointerId: e.pointerId,
          pointerType: e.pointerType,
          isPrimary: e.isPrimary,
        })
      );
    }
    function stop() {
      doc.removeEventListener('pointermove', onMove, true);
      doc.removeEventListener('pointerup', stop, true);
      doc.removeEventListener('pointercancel', stop, true);
    }
    // Capture, so this runs ahead of dnd-kit's own move handler on the
    // document; the real release or a cancel ends the watch.
    doc.addEventListener('pointermove', onMove, true);
    doc.addEventListener('pointerup', stop, true);
    doc.addEventListener('pointercancel', stop, true);
  }
}
